import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBInput,
} from "mdb-react-ui-kit";
import { useMessageBox } from "../components/Common/MessageBox";

const ProductDetailsPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { showSuccess, MessageBoxComponent } = useMessageBox();

  // Always call hooks at top-level
  const [editableProduct, setEditableProduct] = useState(
    state?.product || null,
  );

  if (!editableProduct) {
    return <p className="text-center mt-5">No product data found</p>;
  }

  const { marketplaces } = editableProduct;

  const handleFieldChange = (key, value) => {
    setEditableProduct((prev) => ({ ...prev, [key]: value }));
  };

  const handleMarketplaceChange = (market, key, value) => {
    setEditableProduct((prev) => ({
      ...prev,
      marketplaces: {
        ...prev.marketplaces,
        [market]: { ...prev.marketplaces[market], [key]: value },
      },
    }));
  };

  const handleSave = () => {
    console.log("Saved Product:", editableProduct);
    showSuccess("Changes saved! (Check console for object)");
  };

  return (
    <MDBContainer className="py-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Product Details</h3>
        <MDBBtn color="danger" outline onClick={() => navigate(-1)}>
          Back
        </MDBBtn>
      </div>

      {/* Global Product Info */}
      <div
        className="mb-4 p-4 rounded shadow-sm"
        style={{ background: "#fff", borderLeft: "4px solid #dc3545" }}
      >
        <h5 className="text-danger mb-4">General Information</h5>
        <MDBRow>
          {[
            "title",
            "description",
            "price",
            "category",
            "condition",
            "quantity",
            "sku",
            "brand",
          ].map((key) => (
            <MDBCol md="6" lg="4" className="mb-3" key={key}>
              <MDBInput
                label={key.charAt(0).toUpperCase() + key.slice(1)}
                value={editableProduct[key]}
                onChange={(e) => handleFieldChange(key, e.target.value)}
              />
            </MDBCol>
          ))}
        </MDBRow>
      </div>

      {/* Marketplace Panels */}
      {Object.entries(marketplaces).map(([market, fields]) => (
        <div
          key={market}
          className="mb-4 p-4 rounded shadow-sm"
          style={{ background: "#fff", borderLeft: "4px solid #dc3545" }}
        >
          <h5 className="text-danger mb-4 text-capitalize">{market} Listing</h5>

          <MDBRow>
            {Object.entries(fields).map(([key, value]) => (
              <MDBCol md="6" lg="4" className="mb-3" key={key}>
                <MDBInput
                  label={key}
                  value={value}
                  onChange={(e) =>
                    handleMarketplaceChange(market, key, e.target.value)
                  }
                />
              </MDBCol>
            ))}
          </MDBRow>
        </div>
      ))}

      {/* Action Buttons */}
      <div className="d-flex justify-content-end gap-2 mt-4">
        <MDBBtn color="danger" onClick={handleSave}>
          Save Changes
        </MDBBtn>
        <MDBBtn color="danger" outline onClick={() => navigate(-1)}>
          Cancel
        </MDBBtn>
      </div>
      <MessageBoxComponent />
    </MDBContainer>
  );
};

export default ProductDetailsPage;
